import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { pagesApi } from "../api/pagesApi";
import Error404 from "../pages/Error404";


export default function RequireActivePage({ children }) {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    const controller = new AbortController();
    let alive = true;

    async function check() {
      setState({ loading: true, ok: false });

      try {
        const page = await pagesApi.getBySlug(slug, { signal: controller.signal });
        const isActive = typeof page?.active === "boolean" ? page.active : true;

        if (!alive) return;
        setState({ loading: false, ok: !!isActive });
      } catch (e) {
        if (!alive) return;
        if (e?.name === "AbortError") return;
        setState({ loading: false, ok: false });
      }
    }

    if (slug) check();

    return () => {
      alive = false;
      controller.abort();
    };
  }, [slug]);

  if (state.loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-600">Loading…</div>
      </div>
    );
  }

  if (!state.ok) return <Error404 slug={slug} />;

  return children;
}
